import { render, staticRenderFns } from "./cart-features.vue?vue&type=template&id=7dd2f705&scoped=true&"
import script from "./cart-features.vue?vue&type=script&lang=js&"
export * from "./cart-features.vue?vue&type=script&lang=js&"
import style0 from "./cart-features.vue?vue&type=style&index=0&id=7dd2f705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd2f705",
  null
  
)

export default component.exports